/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Macarons_TitleInputs */

const en_macarons_title = /** @type {(inputs: Macarons_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macarons`)
};

const ar_macarons_title = /** @type {(inputs: Macarons_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ماكارون`)
};

const de_macarons_title = /** @type {(inputs: Macarons_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macarons`)
};

const es_macarons_title = /** @type {(inputs: Macarons_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macarons`)
};

const fr_macarons_title = /** @type {(inputs: Macarons_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macarons`)
};

const it_macarons_title = /** @type {(inputs: Macarons_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macaron`)
};

const ja_macarons_title = /** @type {(inputs: Macarons_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マカロン`)
};

const ko_macarons_title = /** @type {(inputs: Macarons_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`마카롱`)
};

const pt_br_macarons_title = /** @type {(inputs: Macarons_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macarons`)
};

const ru_macarons_title = /** @type {(inputs: Macarons_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Макароны`)
};

const th_macarons_title = /** @type {(inputs: Macarons_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`มาการอง`)
};

const tr_macarons_title = /** @type {(inputs: Macarons_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Makaron`)
};

const zh_cn_macarons_title = /** @type {(inputs: Macarons_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`马卡龙`)
};

const zh_tw_macarons_title = /** @type {(inputs: Macarons_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`馬卡龍`)
};

/**
* | output |
* | --- |
* | "Macarons" |
*
* @param {Macarons_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const macarons_title = /** @type {((inputs?: Macarons_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Macarons_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_macarons_title(inputs)
	if (locale === "ar") return ar_macarons_title(inputs)
	if (locale === "de") return de_macarons_title(inputs)
	if (locale === "es") return es_macarons_title(inputs)
	if (locale === "fr") return fr_macarons_title(inputs)
	if (locale === "it") return it_macarons_title(inputs)
	if (locale === "ja") return ja_macarons_title(inputs)
	if (locale === "ko") return ko_macarons_title(inputs)
	if (locale === "pt_br") return pt_br_macarons_title(inputs)
	if (locale === "ru") return ru_macarons_title(inputs)
	if (locale === "th") return th_macarons_title(inputs)
	if (locale === "tr") return tr_macarons_title(inputs)
	if (locale === "zh_cn") return zh_cn_macarons_title(inputs)
	return zh_tw_macarons_title(inputs)
});